import {
  Badge,
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { colors, toggleButtonGroupStyle } from "@/theme/eventsTokens.ts";

function toToggleValue(value: boolean | null): string {
  if (value === true) return "with";
  if (value === false) return "without";
  return "all";
}

export function FilterBadge({
  count,
  icon,
  label,
}: {
  readonly count: number;
  readonly icon: React.ReactNode;
  readonly label: string;
}) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}>
      <Badge
        badgeContent={count}
        color="primary"
        sx={{
          "& .MuiBadge-badge": {
            fontSize: "0.65rem",
            minWidth: 16,
            height: 16,
          },
        }}
      >
        {icon}
      </Badge>
      <Typography sx={{ fontSize: "0.8125rem", fontWeight: 500, color: colors.textPrimary }}>
        {label}
      </Typography>
    </Box>
  );
}

export function ToggleSection({
  label,
  value,
  onChange,
}: {
  readonly label: string;
  readonly value: boolean | null;
  readonly onChange: (v: boolean | null) => void;
}) {
  const mapped = toToggleValue(value);
  return (
    <Box data-testid={`toggle-${label.toLowerCase().replace(/\s+/g, "-")}`} sx={{ mb: 1.5 }}>
      <Typography
        variant="caption"
        sx={{ color: colors.textMuted, fontWeight: 500, display: "block", mb: 0.5 }}
      >
        {label}
      </Typography>
      <ToggleButtonGroup
        value={mapped}
        exclusive
        onChange={(_e, v: string | null) => {
          if (v === "with") onChange(true);
          else if (v === "without") onChange(false);
          else onChange(null);
        }}
        size="small"
        fullWidth
        sx={toggleButtonGroupStyle}
      >
        <ToggleButton value="with">With</ToggleButton>
        <ToggleButton value="all">All</ToggleButton>
        <ToggleButton value="without">Without</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}
